<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 100 100"
        :style="rootStyle"
    >
        <g :stroke="INK_300" stroke-width="0.6" fill="none">
            <line x1="0" y1="0" x2="100" y2="0" />
            <line x1="20" y1="20" x2="100" y2="20" />
            <line x1="40" y1="40" x2="100" y2="40" />
            <line x1="100" y1="0" x2="0" y2="100" />
            <line x1="100" y1="20" x2="20" y2="100" />
            <line x1="100" y1="40" x2="40" y2="100" />
            <circle cx="80" cy="60" r="8" />
            <circle cx="60" cy="80" r="8" />
        </g>
    </svg>
</template>

<script>
import { INK_300 } from './tokens';

// Position + transform lookups for each of the four corners.
// Values mirror the prototype's CornerOrnament(corner=...) helper.
const POSITIONS = {
    tl: { top: 0,    left: 0 },
    tr: { top: 0,    right: 0 },
    bl: { bottom: 0, left: 0 },
    br: { bottom: 0, right: 0 },
};
const TRANSFORMS = {
    tl: 'rotate(180deg)',
    tr: 'scaleY(-1)',
    bl: 'scaleX(-1)',
    br: '',
};

export default {
    name: 'CornerOrnament',
    props: {
        corner: {
            type: String,
            default: 'tr',
            validator: (v) => ['tl', 'tr', 'bl', 'br'].includes(v),
        },
        size: { type: Number, default: 110 },
        opacity: { type: Number, default: 0.45 },
    },
    data() {
        return { INK_300 };
    },
    computed: {
        rootStyle() {
            return {
                position: 'absolute',
                pointerEvents: 'none',
                opacity: this.opacity,
                transform: TRANSFORMS[this.corner],
                ...POSITIONS[this.corner],
            };
        },
    },
};
</script>
